import { Country, State } from 'country-state-city';
import { i18n } from '../i18n';

export type CountryCityOption = {
  label: string;
  value: string;
  lng: number;
  lat: number;
};

const sortByValue = <T extends { value: string }>(items: T[]) => {
  return items.sort((a, b) => a.value.localeCompare(b.value));
};

export const countries = sortByValue<CountryCityOption>([
  { label: i18n.t('countryCity.russia'), value: 'Russia', lng: 105.3188, lat: 61.524 },
  { label: i18n.t('countryCity.kazakhstan'), value: 'Kazakhstan', lng: 68, lat: 48 },
  {
    label: i18n.t('countryCity.saudiArabia'),
    value: 'Saudi Arabia',
    lng: 45.0792,
    lat: 23.8859,
  },
  { label: i18n.t('countryCity.uzbekistan'), value: 'Uzbekistan', lng: 64, lat: 41 },
  { label: i18n.t('countryCity.turkey'), value: 'Turkey', lng: 35, lat: 39 },
]);

export const cities: Record<string, CountryCityOption[]> = {
  Russia: sortByValue([
    { label: i18n.t('countryCity.barnaul'), value: 'Barnaul', lng: 83.7636, lat: 53.3481 },
    { label: i18n.t('countryCity.biysk'), value: 'Biysk', lng: 85.2072, lat: 52.5394 },
    {
      label: i18n.t('countryCity.yekaterinburg'),
      value: 'Yekaterinburg',
      lng: 60.6057,
      lat: 56.8389,
    },
    { label: i18n.t('countryCity.izhevsk'), value: 'Izhevsk', lng: 53.2045, lat: 56.8527 },
    { label: i18n.t('countryCity.kazan'), value: 'Kazan', lng: 49.1064, lat: 55.7961 },
    { label: i18n.t('countryCity.kemerovo'), value: 'Kemerovo', lng: 86.0873, lat: 55.3547 },
    {
      label: i18n.t('countryCity.krasnoyarsk'),
      value: 'Krasnoyarsk',
      lng: 92.8672,
      lat: 56.0106,
    },
    { label: i18n.t('countryCity.kurgan'), value: 'Kurgan', lng: 65.3411, lat: 55.4408 },
    { label: i18n.t('countryCity.moscow'), value: 'Moscow', lng: 37.6173, lat: 55.7558 },
    {
      label: i18n.t('countryCity.naberezhnyeChelny'),
      value: 'Naberezhnye Chelny',
      lng: 52.407,
      lat: 55.7436,
    },
    {
      label: i18n.t('countryCity.nizhnyNovgorod'),
      value: 'Nizhny Novgorod',
      lng: 44.0059,
      lat: 56.3269,
    },
    {
      label: i18n.t('countryCity.novokuznetsk'),
      value: 'Novokuznetsk',
      lng: 87.1099,
      lat: 53.7596,
    },
    {
      label: i18n.t('countryCity.novosibirsk'),
      value: 'Novosibirsk',
      lng: 82.9204,
      lat: 55.0302,
    },
    { label: i18n.t('countryCity.perm'), value: 'Perm', lng: 56.2294, lat: 58.0105 },
    { label: i18n.t('countryCity.tomsk'), value: 'Tomsk', lng: 84.9482, lat: 56.4846 },
    { label: i18n.t('countryCity.tyumen'), value: 'Tyumen', lng: 65.5343, lat: 57.153 },
    { label: i18n.t('countryCity.ulyanovsk'), value: 'Ulyanovsk', lng: 48.4031, lat: 54.3142 },
    { label: i18n.t('countryCity.ufa'), value: 'Ufa', lng: 55.9587, lat: 54.7355 },
    {
      label: i18n.t('countryCity.chelyabinsk'),
      value: 'Chelyabinsk',
      lng: 61.4026,
      lat: 55.1599,
    },
    {
      label: i18n.t('countryCity.cheboksary'),
      value: 'Cheboksary',
      lng: 47.2519,
      lat: 56.1439,
    },
  ]),
  Kazakhstan: sortByValue([
    { label: i18n.t('countryCity.almaty'), value: 'Almaty', lng: 76.92861, lat: 43.25667 },
    { label: i18n.t('countryCity.astana'), value: 'Astana', lng: 71.4491, lat: 51.1694 },
    { label: i18n.t('countryCity.shymkent'), value: 'Shymkent', lng: 69.5901, lat: 42.3167 },
  ]),
  'Saudi Arabia': sortByValue([
    { label: i18n.t('countryCity.jeddah'), value: 'Jeddah', lng: 39.1925, lat: 21.4858 },
  ]),
  Uzbekistan: sortByValue([
    { label: i18n.t('countryCity.tashkent'), value: 'Tashkent', lng: 69.2401, lat: 41.2995 },
    { label: i18n.t('countryCity.namangan'), value: 'Namangan', lng: 71.6726, lat: 41.0011 },
    { label: i18n.t('countryCity.samarkand'), value: 'Samarkand', lng: 66.9749, lat: 39.627 },
    { label: i18n.t('countryCity.andijan'), value: 'Andijan', lng: 72.3442, lat: 40.7821 },
    { label: i18n.t('countryCity.nukus'), value: 'Nukus', lng: 59.6103, lat: 42.4531 },
    { label: i18n.t('countryCity.fergana'), value: 'Fergana', lng: 71.7843, lat: 40.3894 },
    { label: i18n.t('countryCity.bukhara'), value: 'Bukhara', lng: 64.4556, lat: 39.7747 },
    { label: i18n.t('countryCity.qarshi'), value: 'Qarshi', lng: 65.7975, lat: 38.861 },
    { label: i18n.t('countryCity.kokand'), value: 'Kokand', lng: 70.9425, lat: 40.5286 },
    { label: i18n.t('countryCity.termez'), value: 'Termez', lng: 67.2721, lat: 37.2242 },
    { label: i18n.t('countryCity.navoiy'), value: 'Navoiy', lng: 65.3792, lat: 40.0844 },
    { label: i18n.t('countryCity.urgench'), value: 'Urgench', lng: 60.6317, lat: 41.55 },
  ]),
  Turkey: sortByValue([
    { label: i18n.t('countryCity.istanbul'), value: 'Istanbul', lng: 28.9784, lat: 41.0082 },
    { label: i18n.t('countryCity.gebze'), value: 'Gebze', lng: 29.4307, lat: 40.8028 },
    { label: i18n.t('countryCity.mersin'), value: 'Mersin', lng: 34.6415, lat: 36.8121 },
    { label: i18n.t('countryCity.izmir'), value: 'Izmir', lng: 27.1428, lat: 38.4237 },
    { label: i18n.t('countryCity.izmit'), value: 'Izmit', lng: 29.9509, lat: 40.7654 },
  ]),
};

export const countryCodes = {
  Russia: 'RU',
  Kazakhstan: 'KZ',
  'Saudi Arabia': 'SA',
  Uzbekistan: 'UZ',
  Turkey: 'TR',
};

export const CountryOptions = Country.getAllCountries().map((country) => country.name);

export const StateOptions = (country: string) => {
  const countryCode = Country.getAllCountries().find((c) => c.name === country)?.isoCode;

  const options = State.getStatesOfCountry(countryCode).map((state) => state.name);

  return options.length > 0 ? options : [country];
};

export const getCountryCityCoordinates = (country: string, city: string) => {
  const fromList =
    cities[country]?.find((item) => item.value === city) ||
    countries.find((item) => item.value === country);

  if (fromList) {
    return {
      lng: Number(fromList.lng),
      lat: Number(fromList.lat),
    };
  }

  return { lng: 0, lat: 0 };
};
